export const primaryColor = "#1890ff";
export const secondaryColor = "whitesmoke";
export const accentColor = "gray";
export const focusColor = "orange"